import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import nl from "./nl.json";

export default { en, fr, de, nl };
